export default {
  'baseline': '기준',
  'current': '현재',
  'aspiration (2030)': 'Aspiration (2030)',
  'not critical': '중요하지 않음',
  'somewhat critical': '다소 중요함',
  'significantly critical': '상당히 중요함',
  'very critical': '매우 중요함',
  'low capacity': '낮은 역량',
  'partial capacity': '다소 높은 역량',
  'significant capacity': 'Significant Capacity',
  'complete capacity': '매우 높은 역량',
  'yes': '예',
  'Unknown/No Data':'알수없음/자료없음',
  'no': '아니오',
  'No':'아니오',
  'unknown': '알수없음',
  'Unknown': '알수없음',
  'Generic User': 'Generic User',
  'National Team Member': 'National Team Member',
  'other': '기타',
  'not applicable': 'Not Applicable',
  'in development': '개발 중',
  'In development': '개발 중',
  'lead ministry/ institution 1': 'Lead Ministry/ Institution 1',
  'lead ministry/ institution 2': 'Lead Ministry/ Institution 2',
  'lead ministry/ institution 3': 'Lead Ministry/ Institution 3',
  'detail': 'Detail',
  'by consultation': 'By consultation',
  'by law (ad-hoc)': 'By law (ad-hoc)',
  'by law (other)': 'By law (other)',
  'policy role is not defined': 'Policy role is not defined',
  'very important': '매우 영향 있음',
  'somewhat important': '다소 영향 있음',
  'not important': '영향 없음',
  'very high': '매우 높음',
  'significant': '상당한',
  'low': '낮은',
  'none': '없음',
  'informal only': '비공식적으로만 있음',
  'other (describe)': 'Other (Describe)',
  'excellent': 'Excellent',
  'adequate': '좋음',
  'Adequate Capacity' : '좋음 역량',
  'No Capacity' : '아니오 역량',
  'no capacity' : '아니오 역량',
  'Inadequate Capacity' : '불충분함 역량',
  'inadequate capacity':'불충분함 역량',
  'adequate capacity':'좋음 역량',
  'inadequate': '불충분함',
  'never': 'Never',
  'sometimes': 'Sometimes',
  'often': 'Often',
  'always': 'Always',
  'junior': 'Junior',
  'senior': 'Senior',
  'director/executive': 'Director/Executive',
  'male': '남성',
  'female': '여성',
  'Score (0-100)': '점수 (0-100)',
  '6.1.1 Proportion of population using': '6.1.1 안전하게 관리되는 식',
  'safely managed drinking water services': '수를 이용하는 인구 비율',
  '6.2.1 Proportion of population using': '6.2.1 안전하게 관리되는 위생시',
  'safely managed sanitation services': '설을 이용하는 인구 비율',
  '6.3.1 Proportion of wastewater safely treated': '6.3.1 안전하게 처리되는 하·폐수의 비율',
  '6.3.2 Proportion of water bodies with good ambient water quality': '6.3.2 좋은 주변 수질을 유지하는 수역의 비율',
  '6.4.1 Change in water use efficiency over time': '6.4.1 시간 경과에 따른 물 사용의 효율성의 변화',
  '6.4.2 Level of water stress: freshwater withdrawal': '6.4.2 물 스트레스의 수준: ',
  'in percentage of available freshwater resources': '이용 가능한 담수 자원 중 취수율',
  '6.5.1 Degree of integrated water resources management': '6.5.1 통합 수자원관리의 정도',
  '6.5.2 Proportion of transboundary basin area with': '6.5.2 물 협력을 위해 운용 협정을',
  'an operational arrangement for water cooperation': '맺은 초국경 유역면적의 비율',
  '6.6.1 Change in the extent of water-related ecosystems over time': ['6.6.1 시간 경과에 따른 수생태계 범위의 변화'],
  'Percentage': '비율',
  'Population using improved sanitation services': '개선된 위생시설을 이용하는 인구',
  'Population using hygiene facility with soap and water at home': '가정에서 비누와 물이 있는 위생시설을 이용하는 인구',
  'Commercial establishments': '상업시설',
  'Non-hazardous industries': '비유해시설',
  'Hazardous industries': '유해시설',
  'Household sources': '가정',
  'Enabling': '이행',
  'environment score': '환경 점수',
  'Institutions and': '기관 및',
  'participation score': '참여도 점수',
  'Management': '관리',
  'instruments score': '수단 점수',
  'Financing score': '재정 점수',
  'Change in the area extent of water-related ecosystems': 'Change in the area extent of water-related ecosystems',
  'Change in quantity of water contained within these ecosystems': 'Change in quantity of water contained within these ecosystems',
  'Capacity building needed at the national level': 'SDG 6 달성을 위하여 국가',
  'to achieve SDG 6 in the country-building': '차원에서 구축이 필요한 역량',
  'Capacity available at the national level': '국가 차원에서 SDG 6',
  'to achieve SDG 6 in the country-available': '달성을 위한 역량',
  'Importance of human resources development for implementation of SDG 6': ['SDG 6실행을 위한 인력 개발의 중요성'],
  'Importance of knowledge and data in implementation of SDG 6': 'SDG 6이행에 있어 지식과 데이터의 중요성',
  'Importance of human capacity to make policy for the implementation of SDG 6': ['SDG 6이행을 위한 정책수립에 있어 인적 역량의 중요성'],
  'Institutions considering structural changes to achieve SDG 6': 'Institutions considering structural changes to achieve SDG 6',
  'Lack of staff and time as an obstacle to achieve SDG 6': 'SDG 6 를 달성하는 데 장애물로써 인력 및 시간 의 부족',
  'Mechanisms existing for cooperation with private sector to achieve SDG 6': ['SDG 6 달성을 위한 민간 부문과의 협력 관련 메 커니즘'],
  'Level of cooperation with other countries to achieve SDG 6': 'SDG 6 달성을 위한 다른 국가와의 협력 수준',
  'Development partners collaborating with government for each SDG 6 indicator': ['각 SDG 6 지표와 관련하여 정부와 협력하는 개 발 파트너'],
  'Number of partners': '파트너 수',
  'Number of events': '이벤트 수',
  'Number of employees': '직원 수',
  'SDG 6 indicator': 'SDG 6 지표',
  'Availability of financial flows for each SDG 6 Indicators': '각 SDG 6 지표에 대한 재정 흐름의 가용성',
  'Estimated funds to achieve each SDG 6 indicators by 2030': '2030 년까지, 각 SDG6 의 달성을 위해 추정되는 총 소요비용',
  'Funds needed and available for each SDG 6 indicators in the current year': '올해 각 SDG6 지표를 위한 소요예산 및 가용예 산',
  'Progress on accountability, attracting funds and funding for equity': ['재무 회계, 자금 유치 및 자본 조달에 대한 진행 도'],
  'Mechanisms for including civil society in': ['SDG 6 와 관련된 재정 수립과정에', '시민 단체가 참여하는 체계'],
  'Available funds as % of funds needed': '필요한 자금 중 이용 가능한 자금의 비율',
  'Positive responses for financial flows': '재정 흐름에 대한 긍정적인 반응',
  'Funds available (\'000,000 USD)': '가용예산 (‘백만 달러)',
  'Funds needed (\'000,000 USD)': '소요예산 (‘백만 달러)',
  'Accountability': '재정적 책임규명',
  'Attracting funds': '자금 유치',
  'Funding for equity': '자본 조달',
  'Gender considerations incorporated by national stakeholders': ['SDG6 에 기여하기 위한 연구과정에서, 국가 이 해 관계자들의 양성평등에 대한 고려'],
  'Gender analysis undertaken to inform national policy': ['SDG 6 관련된 양성평등 국가정책에', '대응하기 위한 성별 분석 수행 여부'],
  'Resources allocation by lead ministry to implement': ['SDG 6 관련하여 양성평등 목표를', '위한 주무부 처의 자원 할당 여부'],
  'Performance-based mechanisms for staff to pursue gender': ['Performance-based mechanisms for staff to pursue gender', 'mainstreaming in their work for SDG 6'],
  'Predicted economic loss and funds allocated to address': ['각 SDG6 지표에 대한 기반시설 재건을 위해 할당된 예상 재정 손실 및 자금'],
  'Protection plans implemented for critical': ['SDG 6 달성을 위한 중요 ', '인프라에 대한 보호 계 획 여부'],
  'Proportion of critical public infrastructure located in': ['각 SDG 6 지표 관련 재해 위험 지역에 ', '위치한 중 요 공공 기반시설의 비율'],
  'Proportion of critical public infrastructure with hazard, risk and': ['각 SDG 6 지표에 대해 위험, 취약성 분석이 ', '이미 완료된 주요 공공 인프라의 비율'],
  'Predicted economic loss': '예상 재정 손실',
  'Funds allocated for post-disaster infrastructure reconstruction': '재난 후 기반시설 재건을 위해 할당된 자금',
  'Transparency in formulation of new policies and implementation': ['Transparency in formulation of new policies and implementation', 'of existing regulations/policies for each SDG 6 indicator'],
  'Fair and equitable access of stakeholders to the': ['Fair and equitable access of stakeholders to the', 'development and implementation of policies for SDG 6'],
  'Integrity training promoted at least once a year': ['Integrity training promoted at least once a year', 'in lead ministries/institutions for SDG 6'],
  'Formulation of new policies': 'Formulation of new policies',
  'Implementation of existing regulations': 'Implementation of existing regulations',
  "No evidence": "정보부족",
  "Significant": "상당한",
  "Adequate": "좋음",
  "Inadequate": "부족",
  "In progress": "개발중",
  "Capacity": "역량",
  "DRR/Resilience": "재난위험경감/대응",
  "Finance": "재정",
  "Gender": "성평등",
  "Indicator": "지표",
  "Integrity": "윤리",
  "Policy & Institutional": "정책 및 제도",
  "Target": "목표",
  "Overall Progress": "역량 구축 진행상황",
  "Overall current capacity": "종합적인 역량 현황",
  "Strengthening mechanisms": "역량 강화 메커니즘",
  "Information and Assessments": "정보 공유 및 평가",
  "Infrastructure": "사회 기반 시설",
  "Strategies": "전략",
  "Adequacy of financial flows": "재정 흐름의 적절성",
  "Financing for equity": "자본 조달",
  "Funding Sources": "자금 출처",
  "Governance": "거버넌스",
  "National policy": "국가 정책",
  "Organisation mainstreaming": "양성평등 교육",                   //Renamed it
  "Policy and Integrity": "정책 및 청렴성",
  "Public Sector Integrity": "공공부문 청렴성",
  "Whistle-blower Protection": "내부고발자 보호",
  "Awareness": "국민 인식",
  "Coordination & cooperation": "조정 및 협력",
  "Policy for equity": "자본 정책",
  "Level of available capacity at the national level for achieving SDG 6": "SDG 6 달성을 위한 국가 차원의 역량 수준",
  'Long-term policy options and mechanisms for building critical ': ['SDG 6 지표에 대한 역량을 구축하기', '위한 국가 차원의 장기 정책 옵션 및 메커니즘'],
  'Human resources development ': ['인재 개발', '및 육성'],
  'Access to information ': ['정보와 지식에 ', '대한 접근성'],
  'Science, technology ': ['과학, 기술 ', '및 혁신'],
  'Inclusion, participation, ': ['소외 계층에 대한 ', '포용, 참여, 평등,', '권한 부여'],
  'Status of policies to align and inform on investments to ': ['SDG 6 관련 양성평등 목표를 이루기', '위한 주무 부처의 투자 조정 정책 여부'],
  'Status of resources allocated to implement gender ': ['SDG 6 관련 양성평등 목표를 ', '실현하기 위해 할 당된 자원 현황'],
  'Consultation with national gender specialists in decision-making for SDG 6': ['SDG 6 와 관련된 의사결정과정에 국가 양성평등 전문가들의 참여 여부'],
  'Institutional commitment to promote gender equality for achieving SDG 6': ['SDG 6 달성을 위한 양성 평등 촉진 관련 제도적 공약 여부'],
  "Staff in lead Ministries/Institutions for each SDG 6 indicator":['SDG 6 지표별 주무부처/기관의 담당직원',''],
  'Staff responsible for addressing water related gender issues in': ['각 SDG6 지표에 대해 주무부처/기관에서 물 관', '련 양성평등 문제를 담당하는 직원 수'],
  'Annual status of training to raise awareness on gender ': ['SDG 6 의 주무부처/기관에서 양성평등에 ', '대한 인식 개선을 위한 연간 교육 여부'],
  'Public awareness efforts led by the national government for achieving SDG 6': ['SDG 6 달성을 위한 정부의 대중 인식 제고 노력'],
  'Status of water related policies for equity at national level for achieving SDG 6 ': ['SDG 6 달성을 위한 국가 차원의 물 관련 정책 현황'],
  'Challenges in water policymaking at national level for achieving SDG 6': ['SDG 6 달성을 위한 국가 차원의 물 정책 수립 과 제'],
  'Events, meetings and workshops organized by the government for each SDG 6 indicator': ['각 SDG 6 지표와 관련해 정부에 의해 개최된 이 벤트, 회의 및 워크숍'],
  'Status of national policies and implementation plans for achieving SDG 6': ['SDG 6 달성을 위한 국가 정책 및 이행 계획의 현 황'],
  'Attribution of roles at the national level for SDG 6': ['SDG 6 에 대한 국가 차원에서의 역할 조정'],
  'chart10_label_policy_component': ['시행되지 않음', '부분적 시행', '완전한 시행'],
  'chart8_label_policy_component': [['수자원과 행정 ', '경계 간 불일치'], ['수자원 ', '할당'], ['지방 및 지방 ', '정부의 역량'], ['환경 ', '규제의 강화'], '경제적 규제', ['제한된 시민 ', '참여']],
  'chart7_label_policy_component': ['빈곤 인구', ['빈민가나 비주거지', ' 거주 인구'], ['외진 곳에', ' 살고 있는 인구'], '토착(원주민) 인구', ['실향민 ', '또는 난민'], '여성', '소수 민족', '장애인', ['질병에', ' 취약한 인구']],
  'Status of national DRR strategies adopted in line with the ': ['SDG 6 달성을 지원하기 위해 센다이 프레임워 ', '크에 따라 채택된 국가 재해위험경감 전략 현황'],
  'Status of integrating climate change adaptation into ': ['SDG 6 를 위한 국가전략에 ', '기후변화 고려 여부'],
  'Status of national funding mechanisms for DRR in support of SDG 6': ['SDG 6 달성을 위한 지원으로 재해위험경감에 대한 국고지원 여부'],
  'Status of independent reviews of the implementation of ': ['SDG 6 관련 재해위험경감 전략 ', '이행에 대한 독 립적인 검토 여부'],
  'Availability status of multi-hazard national risk assessments for SDG 6': ['SDG 6 에 대한 복합재난 국가위험 상태 확인 가 능여부'],
  'Status of policies and mechanisms to make hazard and ': ['SDG 6 관련 위험 데이터에 접근할 수 ', '있도록 하 기 위한 정책 및 메커니즘의 현황'],
  'Programmes to enhance awareness on water-related disaster risks for SDG 6': ['SDG 6 관련 물 관련 재해 위험에 대한 인식을 촉 진하기 위한 프로그램'],
  'Status of funding for post-disaster infrastructure rehabilitation for SDG 6': ['SDG 6 관련 재해 발생 후 인프라 재건을 위한 자 금 지원 현황'],
  'Integrity assessment of water related policymaking for each SDG 6': ['각 SDG 6 관련 물 관련 정책 수립에 대한 윤리성 평가'],
  'Integrity assessment of regulatory processes for achieving SDG 6': ['SDG 6 달성을 위한 규제 프로세스의 윤리성 평 가'],
  'Integrity assessment of international funding for achieving SDG 6': ['SDG 6 달성을 위한 국제 기금에 대한 윤리성 평 가'],
  'Public sector integrity assessment for achieving SDG 6': ['SDG 6 달성을 위한 공공 부문의 윤리성 평가'],
  'Whistle-blower protection assessment for achieving SDG 6': ['SDG 6 달성을 위한 내부고발자 보호에 대한 평 가'],
  'chart1_label_capacity': ['인력', '지식과 데이터', '정책', '법', '과학', '파트너십', '평등', '기타'],
  'chart2_label_capacity': ['민간 부문과의 협력', '재정', '성과 지표', '시민 참여', '시민 사회단체', '데이터', '관습에 따른 합의', '워크샵', '성과 모니터링', '기타'],
  'chart11_label_policy': ['수자원 장관', '부처', ['주요 물 ', '관련 기관'], ['특별 고위급 ', '구조(국가협의회 등)'], '부처 간 조직', '기관 간 프로그램', ['특별한 조정 ', '메커니즘 ', 'mechanism'], '없음'],
  "Mechanisms addressing capacity building at the national":["SDG 6지표 관련 국가 차원의 역량 강화를다루는 방안"],
  "Level of available capacity at the national level":"SDG 6 지표 달성을 위해 국가 차원에서 가용한 역량 수준",
  "Lead Ministries/Institutions on track to build critical":['SDG 6 지표 실행 계획을 지원하는 핵심적인 역량을 구축하는',' 주무  부처/기관'],
  "Estimated proportion of funds available in relation to":['SDG6 지표에 필요한 자금과 비교하여 사용할 수','있는 자금의  추정 비율'],
  "Financing and expenditure plans developed and publicly":['SDG 6 지표를 위해 개발되고 공적으로 이용 가능한','자금 조달 및 지출 계획'],
  "Mechanisms for including civil society in the financial":['SDG 6 지표를 위해 재정 계획 과정에','시민사회를 포함하는 방안'],
  "Established financial accountability mechanisms for":['SDG 6 지표를 위해 수립된 재정 책임성 확보 방안'],
  "Securing different funding sources to support national":['SDG 6 지표와 관련한 국가 정책 및 이행을 지원할 수 있는','다양한 자금 출처의 확보 방안'],
  "Incentives for environmentally sustainable and efficient":['SDG 6 지표에 관한 환경적으로 지속 가능하고','효율적인 기술에 대한 인센티브'],
  'National policies and implementation plans for SDG 6': 'SDG6지표를 위한 국가 정책 및 이행계획',
  "Mechanisms to reach specific population groups for SDG 6":['SDG6 지표와 관련하여','특정 인구집단을 고려하는 방안'],
  "Mechanisms for the allocation of responsibilities among lead":['SDG6 지표와 관련하여','주무 부처/기관 간 책임 할당 방안'],
  "Mechanisms adopted to address the lack of reliable data for":["SDG6 지표에 대한 신뢰성 있는 자료의 부족을","해결하기 위해 도입된 방안"],
  "Cooperation with private sector to achieve SDG 6":["SDG6 지표 달성을 위한 민간 부문과의 협력"],
  "Cooperation with the development partners (international organizations, donors, NGOs)":['SDG6 지표 달성을 위한','개발 파트너(국제기구, 기부자, NGO 등)와의 협력'],
  "Level of cooperation and exchange of information with other":['SDG6 지표를 위한 다른 국가와의 정보 공유 및 경험 ','공유 등 협력 수준'],
  "Public awareness campaigns organized to inform citizens on":['SDG6 지표의 도전과 진행 상황을 시민들에게 알리기 위한','공공 인식제고 캠페인'],
  "Gender mainstreaming objectives considered for":['SDG6지표를 위해 검토된 성 주류화 목표'],
  //"Gender mainstreaming objectives considered for":['Objetivos de integração de gênero considerados para','os indicadores do ODS 6'],
  'Gender analysis undertaken to inform national policies ':['SDG6지표 관련 국가정책에 반영하기 위한 성별 분석 수행'],
  //'Gender analysis undertaken to inform national policies ':['Análise de gênero realizada para informar as políticas nacionais para os','indicadores do ODS 6'],
  "Gender dimensions incorporated by national stakeholders ":['SDG6 지표 연구에 대한','국가 이해관계자들의 젠더 관점 포함 여부'],
  //"Gender dimensions incorporated by national stakeholders ":['Dimensões de gênero incorporadas pelos atores nacionais em estudos','para os indicadores do ODS 6'],
  "Adequate resources allocated to implement gender ":['SDG6 지표에 대한 성 주류화 목표를 구현하기 위해','할당된 적정한 자원'],
  //"Adequate resources allocated to implement gender ":['Recursos adequados alocados para implementar as metas de integração de gênero','para os indicadores ODS 6'],
  "Inclusion of gender specialists in decison-making processes":['SDG6 지표 관련 의사결정 과정에 젠더 전문가 포함 여부'],
  //"Inclusion of gender specialists in decison-making processes":['Inclusão de especialistas em gênero nos processos de tomada de decisão para','os indicadores do ODS 6'],
  "Training to raise awareness on gender equality within lead":['SD6 지표를 위한 주무 부처/기관 내 성평등 교육'],
  //"Training to raise awareness on gender equality within lead":['Treinamento a conscientização sobre a igualdade de gênero nos principais','ministérios / instituições para os indicadores do ODS 6'],
  "National DRR strategies adopted in line ":['SDG6 지표를 위해 센다이 강령에 따라 채택된','국가 재난위험경감 전략'],
  "Integration of climate change adaptation into ":['SDG6 지표에 대한 국가 전략에 기후 변화 적응의 통합 여부'],
  "National funding mechanisms for DRR strategies for SDG 6 indicators":['SDG6 지표에 대한 재난위험경감 전략을 위한 국가적 자금지원 방안'],
  "Independent reviews of the implementation of DRR":['SDG6 지표를 위한 재난위험경감 전략 시행에 대한 제3자 검토'],
  "Hazard and risk data accessible and available to the public":['SDG6를 위한 재난위험 자료에 대한 대중의 접근 및 이용가능 여부'],
  'Mechanisms of accountability to prevent and detect' : ['SDG6 지표의 부패를 방지하고 탐지하는 책임성 확보 방안'],
  "Fair and equitable access to the development and implementation":["SDG6 지표에 대한 정책 개발 및 시행에의 공정하고 평등한 접근 여부"],
  'Regulatory processes are simple and transparent ':['SDG6 지표에 대한 규제 절차 투명성'],
  "Anti-corruption action plans shared between government and ":[" SDG6 지표에 대해 정부와 기부자 간에 반부패 행동 계획 공유 여부"],
  'Public financial management and procurement used to prevent' : ["SDG6 지표의 공공 재정관리 부패를 예방하고 감지하는데 사용되는","공공 재정관리 및 조달"],




};



// WEBPACK FOOTER //
// ./src/app/sdg/globals/en_to_ko.ts